export const PosicaoDeDispositivosAlarmeDeIncendio = {
    /* Térreo */
    "1-1": { x: 50, y: 30 },
    /* Segundo andar */
    "1-7": { x: 54, y: 30 },
    /* Áreas técnicas */
    "1-47": { x: 52, y: 35 },
};